// extracted by mini-css-extract-plugin
export default {"projects__wrapper":"Projects_projects__wrapper__v6qxq"};